/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.unifiedaccount.rpc.AppRpc
 */

export let ComHubspotUnifiedAccountApiModelsAppsGetsupportedappGetSupportedAppErrorIF;
(function (_ComHubspotUnifiedAccountApiModelsAppsGetsupportedappGetSupportedAppErrorIF) {})(ComHubspotUnifiedAccountApiModelsAppsGetsupportedappGetSupportedAppErrorIF || (ComHubspotUnifiedAccountApiModelsAppsGetsupportedappGetSupportedAppErrorIF = {}));
export let ComHubspotUnifiedAccountApiModelsAppsListsupportedappsListSupportedAppsErrorIF;
(function (_ComHubspotUnifiedAccountApiModelsAppsListsupportedappsListSupportedAppsErrorIF) {})(ComHubspotUnifiedAccountApiModelsAppsListsupportedappsListSupportedAppsErrorIF || (ComHubspotUnifiedAccountApiModelsAppsListsupportedappsListSupportedAppsErrorIF = {}));
export const listSupportedAppsRpc = {
  serviceName: 'com.hubspot.unifiedaccount.rpc.AppRpc',
  rpcName: 'listSupportedApps',
  auth: 'app',
  fingerprint: 'PEFzqXzsoBzdvyshNQmtC39-XLLiJVZ0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSupportedAppRpc = {
  serviceName: 'com.hubspot.unifiedaccount.rpc.AppRpc',
  rpcName: 'getSupportedApp',
  auth: 'app',
  fingerprint: 'EfC2_cXrvnUyksjrF6Te1sNkGmZ1Bl6E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};